"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListValue = exports.DataListLabel = exports.DataListItem = exports.DataListRoot = void 0;
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const React = tslib_1.__importStar(require("react"));
const text_js_1 = require("./text.js");
const index_js_1 = require("../helpers/index.js");
const data_list_props_js_1 = require("./data-list.props.js");
const DataListRoot = React.forwardRef((props, forwardedRef) => {
    const { className, ...dataListProps } = (0, index_js_1.extractProps)(props, data_list_props_js_1.dataListPropDefs, index_js_1.marginPropDefs);
    return (React.createElement(text_js_1.Text, { asChild: true },
        React.createElement("dl", { ...dataListProps, ref: forwardedRef, className: (0, classnames_1.default)(className, 'rt-DataListRoot') })));
});
exports.DataListRoot = DataListRoot;
DataListRoot.displayName = 'DataListRoot';
const DataListItem = React.forwardRef((props, forwardedRef) => {
    const { className, ...itemProps } = (0, index_js_1.extractProps)(props, data_list_props_js_1.dataListItemPropDefs);
    return (React.createElement("div", { ...itemProps, ref: forwardedRef, className: (0, classnames_1.default)(className, 'rt-DataListItem') }));
});
exports.DataListItem = DataListItem;
DataListItem.displayName = 'DataListItem';
const DataListLabel = React.forwardRef((props, forwardedRef) => {
    const { className, color, ...labelProps } = (0, index_js_1.extractProps)(props, data_list_props_js_1.dataListLabelPropDefs);
    return (React.createElement("dt", { ...labelProps, "data-accent-color": color, ref: forwardedRef, className: (0, classnames_1.default)(className, 'rt-DataListLabel') }));
});
exports.DataListLabel = DataListLabel;
DataListLabel.displayName = 'DataListLabel';
const DataListValue = React.forwardRef(({ children, className, ...props }, forwardedRef) => (React.createElement("dd", { ...props, ref: forwardedRef, className: (0, classnames_1.default)(className, 'rt-reset', 'rt-DataListValue') }, children)));
exports.DataListValue = DataListValue;
DataListValue.displayName = 'DataListValue';
//# sourceMappingURL=data-list.js.map